import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import "../../web/src/resources/css/style.css";
import { ThemeProvider } from "@material-ui/core";
import { theme } from "./Theme/theme.js";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "@trendmicro/react-paginations/dist/react-paginations.css";

// ✅ SIMPLE CHECK - If this is a popup with auth hash, show minimal UI
const isAuthPopup =
  window.opener &&
  window.opener !== window &&
  window.location.hash &&
  (window.location.hash.includes("code=") ||
    window.location.hash.includes("error="));

// Service worker registration
if ("serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    try {
      const registration = await navigator.serviceWorker.register(
        "/firebase-messaging-sw.js",
        { scope: "/", updateViaCache: "none" },
      );
      console.log("SW registered:", registration);
      registration.update();
      registration.addEventListener("updatefound", () => {
        console.log("Service worker update found");
      });
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        console.log("Controller changed, reloading page");
        window.location.reload();
      });
    } catch (error) {
      console.error("SW registration failed:", error);
    }
  });
}

// ✅ CONDITIONAL RENDERING
if (isAuthPopup) {
  // Render minimal UI for auth popup
  ReactDOM.render(
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        fontFamily: "sans-serif",
      }}>
      <div style={{ textAlign: "center" }}>
        <div>Completing login...</div>
        <div style={{ fontSize: "12px", marginTop: "10px" }}>
          This window will close shortly
        </div>
      </div>
    </div>,
    document.getElementById("root"),
  );

  // Auto-close popup after 5 seconds
  setTimeout(() => window.close(), 5000);
} else {
  // Normal app rendering
  ReactDOM.render(
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <App />
          <ToastContainer
            position='top-center'
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Provider>
      </ThemeProvider>
    </React.StrictMode>,
    document.getElementById("root"),
  );
}

reportWebVitals();
